import { OrderFlowProvider } from '../../providers/OrderProvider';
import { DialogProvider } from '../../providers/OrderDialog';

export default function RentalProviders ({ children }) {
  return (
    <DialogProvider>
      <OrderFlowProvider>
        {children}
      </OrderFlowProvider>
    </DialogProvider>
  );
}